var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui--approval-container" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchUserNm,
            expression: "searchUserNm"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          placeholder: _vm.$t("sdl.common.label.payer"),
          "aria-label": "add User"
        },
        domProps: { value: _vm.searchUserNm },
        on: {
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.searchUserNm = ""
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.openSearchUser()
            }
          ],
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchUserNm = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            attrs: { type: "button" },
            on: { click: _vm.openSearchUser }
          },
          [_c("em", { staticClass: "icon-magnifier" })]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ui--approval-list" }, [
      _c("div", { staticClass: "ui--approval-button" }, [
        _c("div", { staticClass: "ui--apv-flex" }, [
          _c(
            "button",
            {
              staticClass: "btn ui--btn-apv-outline",
              class: { on: _vm.approvalType === "APPROVAL" },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.changeApprovalType("APPROVAL")
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sdl.approval.label.APPROVE")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn ui--btn-apv-outline",
              class: { on: _vm.approvalType === "AGREEMENT" },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.changeApprovalType("AGREEMENT")
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sdl.approval.label.AGREEMENT")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn ui--btn-apv-outline",
              class: { on: _vm.approvalType === "NOTIFICATION" },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.changeApprovalType("NOTIFICATION")
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sdl.approval.label.NOTIFY")) +
                  "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ui--slide ml-2 mr-2" }, [_vm._v("|")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-xs",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.changeApprovalType("EX_POST_APPROVAL")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.approval.label.SKIP")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "ui--slide ml-2 mr-2" }, [_vm._v("|")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-xs",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.setApprovalParallel(true)
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("view_stream")]),
            _vm._v(_vm._s(_vm.$t("sdl.common.label.parallel")) + "\n      ")
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-xs",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.setApprovalParallel(false)
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("view_module")]),
            _vm._v(
              _vm._s(_vm.$t("sdl.approval.label.PARALLEL_CANCEL")) + "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _vm.showRequired
          ? _c("span", { staticClass: "ui--slide ml-2 mr-2" }, [_vm._v("|")])
          : _vm._e(),
        _vm._v(" "),
        _vm.showRequired
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-info btn-xs",
                staticStyle: { position: "relative" },
                attrs: { type: "button" },
                on: { click: _vm.onRequiredApprListPopup }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("sdl.approval.label.addRequiredApprovalUser")
                    ) +
                    "\n        "
                ),
                _vm.showRequiredTooltip
                  ? _c("div", { staticClass: "app-required" }, [
                      _c("em", { staticClass: "icon-info" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "sdl.approval.message.selectRequiredApprovalUser"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showRequired
          ? _c("span", { staticClass: "ui--slide ml-2 mr-2" }, [_vm._v("|")])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-icon-sm",
            attrs: { title: _vm.$t("sdl.common.label.Top"), type: "button" },
            on: {
              click: function($event) {
                return _vm.stepTopUp()
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons ui--trans-rotate-270" }, [
              _vm._v("skip_next")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-icon-sm",
            attrs: { title: _vm.$t("sdl.common.label.moveup"), type: "button" },
            on: {
              click: function($event) {
                return _vm.stepUp()
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons ui--trans-rotate-270" }, [
              _vm._v("play_arrow")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-icon-sm",
            attrs: {
              title: _vm.$t("sdl.common.label.movedown"),
              type: "button"
            },
            on: {
              click: function($event) {
                return _vm.stepDown()
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons ui--trans-rotate-90" }, [
              _vm._v("play_arrow")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-icon-sm",
            attrs: { title: _vm.$t("sdl.common.label.bottom"), type: "button" },
            on: {
              click: function($event) {
                return _vm.stepBottomDown()
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons ui--trans-rotate-90" }, [
              _vm._v("skip_next")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn ui--btn-icon-sm",
            attrs: { title: _vm.$t("sdl.common.label.delete"), type: "button" },
            on: { click: _vm.deleteUserTopBtn }
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("clear")])]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "ui--slide ml-2 mr-2" }, [_vm._v("|")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("sdl.common.label.total"))),
          _c("strong", { staticClass: "ml-1 mr-2" }, [
            _vm._v(_vm._s(_vm.apprPathList.length))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.apprPathList, function(user) {
          return _c(
            "li",
            {
              key: user.userId + "_" + user.stepIdx,
              class: {
                selected: user.selected,
                draft: user.approvalType === "DRAFTING"
              },
              on: {
                click: function($event) {
                  return _vm.selectedPath(user)
                }
              }
            },
            [
              _c("span", { staticClass: "count" }, [
                _vm._v(_vm._s(user.stepIdx))
              ]),
              _vm._v(" "),
              user.approvalType === "DRAFTING"
                ? _c("div", { staticClass: "ui--apv-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv btn-apv-request",
                        attrs: { type: "button" }
                      },
                      [_vm._v(_vm._s(_vm.$t("sdl.approval.label.REQUEST")))]
                    )
                  ])
                : user.approvalType === "EX_POST_APPROVAL"
                ? _c("div", { staticClass: "ui--apv-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv btn-apv-after on",
                        attrs: { type: "button" }
                      },
                      [_vm._v(_vm._s(_vm.$t("sdl.approval.label.SKIP")))]
                    )
                  ])
                : user.approvalType === "PARALLEL_APPROVAL"
                ? _c("div", { staticClass: "ui--apv-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv ui--btn-apv-approve on",
                        attrs: { type: "button" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("sdl.approval.label.PARALLEL_APPROVE")
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                : user.approvalType === "PARALLEL_AGREEMENT"
                ? _c("div", { staticClass: "ui--apv-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv ui--btn-apv-approve on",
                        attrs: { type: "button" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("sdl.approval.label.PARALLEL_AGREEMENT")
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                : _c("div", { staticClass: "ui--apv-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv ui--btn-apv-approve",
                        class: { on: user.approvalType === "APPROVAL" },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.changeUserApprovalType(user, "APPROVAL")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("sdl.approval.label.APPROVE")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv ui--btn-apv-agreement",
                        class: { on: user.approvalType === "AGREEMENT" },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.changeUserApprovalType(user, "AGREEMENT")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("sdl.approval.label.AGREEMENT")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-apv ui--btn-apv-notice",
                        class: { on: user.approvalType === "NOTIFICATION" },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.changeUserApprovalType(
                              user,
                              "NOTIFICATION"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("sdl.approval.label.NOTIFY")) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
              _vm._v(" "),
              !user.required
                ? _c("span", { staticClass: "name" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(user.userName) +
                        "/" +
                        _vm._s(user.deptName) +
                        "/" +
                        _vm._s(user.compName)
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              user.required
                ? _c("span", { staticClass: "name" }, [
                    _c("span", { staticClass: "text-info" }, [
                      _vm._v(
                        _vm._s(user.userName) +
                          "/" +
                          _vm._s(user.deptName) +
                          "/" +
                          _vm._s(user.compName) +
                          " (" +
                          _vm._s(
                            _vm.$t("sdl.approval.label.requiredApprovalUser")
                          ) +
                          ")"
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              user.approvalType === "DRAFTING"
                ? _c("div", { staticClass: "ui--apv-right text-black-50" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("sdl.common.label.requester")) +
                        "\n        "
                    )
                  ])
                : _c("div", { staticClass: "ui--apv-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-icon-xs",
                        class: { on: user.routeModify },
                        attrs: {
                          title: _vm.$t("sdl.common.label.pathchange"),
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.approvalRouteModify(user)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("contacts")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-icon-xs",
                        class: { on: user.bodyModify },
                        attrs: {
                          title: _vm.$t("sdl.approval.label.BODYMODIFY"),
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.approvalBodyModify(user)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("text_fields")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-icon-xs",
                        class: { on: user.arbitrary },
                        attrs: {
                          title: _vm.$t("sdl.approval.label.ARBITRARY"),
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.approvalArbitrary(user)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("border_color")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn ui--btn-icon-sm float-right",
                        attrs: {
                          title: _vm.$t("sdl.common.label.delete"),
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteUserRightBtn(user)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("clear")
                        ])
                      ]
                    )
                  ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-759a9929", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759a9929","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/approvalpath/ApprovalPath.vue
// module id = null
// module chunks = 